import React from 'react'
import { css } from '@emotion/core'
import { ApprovedStatusType } from '@/models/reservation-approved-status'
import { useTranslation } from 'react-i18next'

type Props = {
  currentStatus: ApprovedStatusType
  onClick?: () => void
  disabled?: boolean
}
export const ApprovedStatusButton: React.FC<Props> = props => {
  const { t } = useTranslation()

  const StatusColor = {
    [ApprovedStatusType.Reservation]: '#F2A40B',
    [ApprovedStatusType.Checkin]: '#F47110',
    [ApprovedStatusType.Stay]: '#3E85CC',
    [ApprovedStatusType.Checkout]: '#7DC931',
  }
  const StatusText = {
    [ApprovedStatusType.Reservation]: t('Reserve'),
    [ApprovedStatusType.Checkin]: t('Checkin'),
    [ApprovedStatusType.Stay]: t('During your stay'),
    [ApprovedStatusType.Checkout]: t('Checkout'),
  }

  return (
    <div
      css={[reservationStatusSelectBoxStyle]}
      style={{
        backgroundColor: StatusColor[props.currentStatus || ApprovedStatusType.Reservation],
        cursor: props.disabled ? 'auto' : 'pointer',
      }}
      onClick={() => props.onClick && props.onClick()}
    >
      {StatusText[props.currentStatus || ApprovedStatusType.Reservation]}
      <img
        css={arrowSelectBoxStyle}
        style={{ visibility: props.disabled ? 'hidden' : 'visible' }}
        src={require('@/static/images/select_white.svg')}
        alt=""
      />
    </div>
  )
}

const reservationStatusSelectBoxStyle = css({
  width: 116,
  height: 26,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  borderRadius: 5,
  border: '1px solid #fff',

  paddingRight: 6,
  fontSize: 12,
  fontWeight: 'bold',
  letterSpacing: 0,
  color: '#fff',
})

const arrowSelectBoxStyle = css({
  position: 'absolute',
  right: 8,
})
